import { TableCell, TableRow } from '@material-ui/core';
import { FieldArrayRenderProps } from 'formik';
import React, { useMemo } from 'react';
import { ILPUBudgetValueFormValue } from '../../../../@types/model/transformer/budget/budget';
import { ITransformerCompany } from '../../../../@types/model/transformer/transformer';
import AppFunctionsService from '../../../../services/appFunctionsService';
import TextFormFastField from '../../../customComponents/form/TextFormFastField';

interface ILPUBudgetFieldArrayProps extends FieldArrayRenderProps {
    hideDetail ?: boolean;

    company : ITransformerCompany | null;
    area : string | null;
    transformer : string | null;
    accountNumber : string | null;
    period : number | null;

    currentPage : number;
    rowsPerPage : number;
}

const LPUBudgetFieldArray = (props : ILPUBudgetFieldArrayProps) : React.ReactElement => {

    const getValues = useMemo<Array<ILPUBudgetValueFormValue>>(() => {
        return props.form.values.values;
    }, [props.form.values.values]);

    const getFilteredValues = useMemo<Array<ILPUBudgetValueFormValue>>(() => {
        const values = getValues;
        const { currentPage, rowsPerPage, company, area, transformer, accountNumber, period } = props;

        return values
            .filter((x: ILPUBudgetValueFormValue) => !company || x.transformer.Company?.id === company.id)
            .filter((x: ILPUBudgetValueFormValue) => !area || x.transformer.Division === area)
            .filter((x: ILPUBudgetValueFormValue) => !transformer || x.transformer.EPNumber === transformer)
            .filter((x: ILPUBudgetValueFormValue) => !accountNumber || x.transformer.AccountNumber === accountNumber)
            .filter((x: ILPUBudgetValueFormValue) => !period || x.month === period)
            .slice((currentPage * rowsPerPage), currentPage * rowsPerPage + rowsPerPage);
    }, [getValues, props.currentPage, props.rowsPerPage, props.company, props.area, props.transformer, props.accountNumber, props.period]);

    const { hideDetail } = props;

    const values = getFilteredValues;

    return (
        <>
            {values.map((n: ILPUBudgetValueFormValue) => (
                <TableRow key={`values_${n.index}`} className={'data-row'}>
                    <TableCell className='fixed'>
                        {
                            AppFunctionsService.formatDateTimeToMonthYearOnly(n.month)
                        }
                    </TableCell>
                    <TableCell className='fixed'>
                        {
                            n.transformer.Company?.name ?? ''
                        }
                    </TableCell>
                    <TableCell className='fixed'>
                        {
                            n.transformer.Division
                        }
                    </TableCell>
                    <TableCell className='fixed'>
                        {
                            n.transformer.EPNumber
                        }
                    </TableCell>
                    {
                        !hideDetail &&
                        <>
                            <TableCell className='fixed'>
                                {
                                    n.transformer.SubArea
                                }
                            </TableCell>
                            <TableCell className='fixed'>
                                {
                                    n.transformer.AccountNumber
                                }
                            </TableCell>
                            <TableCell className='fixed'>
                                {
                                    n.highSeason ? 'High Demand' : 'Low Demand'
                                }
                            </TableCell>
                        </>
                    }
                    <TableCell className='fixed lwb standard'>
                        <TextFormFastField
                            inputProps={{
                                className: 'cw fwb',
                                style: {
                                    textAlign: 'center',
                                },
                            }}
                            id={`values.${n.index}.standardBudget`}
                            name={`values.${n.index}.standardBudget`}
                            fullWidth
                            required
                            type={'number'}
                            color='white'
                        />
                    </TableCell>
                    <TableCell className='fixed lwb peak'>
                        <TextFormFastField
                            inputProps={{
                                className: 'cw fwb',
                                style: {
                                    textAlign: 'center',
                                },
                            }}
                            id={`values.${n.index}.peakBudget`}
                            name={`values.${n.index}.peakBudget`}
                            fullWidth
                            required
                            type={'number'}
                            color='white'
                        />
                    </TableCell>
                    <TableCell className='fixed lwb off-peak'>
                        <TextFormFastField
                            inputProps={{
                                className: 'cw fwb',
                                style: {
                                    textAlign: 'center',
                                },
                            }}
                            id={`values.${n.index}.offpeakBudget`}
                            name={`values.${n.index}.offpeakBudget`}
                            fullWidth
                            required
                            type={'number'}
                            color='white'
                        />
                    </TableCell>
                    <TableCell align='center' className='fixed lwb total cw fwb'>
                        {
                            (n.standardBudget ?? 0) + (n.peakBudget ?? 0) + (n.offpeakBudget ?? 0)
                        }
                    </TableCell>
                    <TableCell className='fixed lwb comment'>
                        <TextFormFastField
                            inputProps={{
                                className: 'cw fwb',
                            }}
                            id={`values.${n.index}.comment`}
                            name={`values.${n.index}.comment`}
                            fullWidth
                            color='white'
                        />
                    </TableCell>
                </TableRow>
            ))}
        </>
    );
};

export default LPUBudgetFieldArray;
